import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CrudService } from '../../services/crud.service';

export interface SupplierInvitationEmailTemplate {
  body: string;
  is_default: boolean;
}

export interface SupplierInvitationEmailTemplateResponse {
  success: boolean;
  data: SupplierInvitationEmailTemplate;
  message: string;
}

export interface SupplierInvitationBrandAsset {
  configured: boolean;
  mime_type?: 'image/png' | 'image/jpeg';
  size_bytes?: number;
  width?: number;
  height?: number;
  checksum?: string;
  updated_at?: string;
}

export interface SupplierInvitationBrandAssetResponse {
  success: boolean;
  data: SupplierInvitationBrandAsset;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class EmailTemplateService {
  private readonly endpoint = `${environment.baseApiUrl}customer/supplier-invitation-email-template`;
  private readonly imageEndpoint = `${this.endpoint}/image`;

  constructor(private crudService: CrudService) {}

  get(): Observable<SupplierInvitationEmailTemplateResponse> {
    return this.crudService.newGetData(this.endpoint);
  }

  update(body: string): Observable<SupplierInvitationEmailTemplateResponse> {
    return this.crudService.updateDataWithoutId(this.endpoint, { body }) as Observable<SupplierInvitationEmailTemplateResponse>;
  }

  getImage(): Observable<SupplierInvitationBrandAssetResponse> {
    return this.crudService.newGetData(this.imageEndpoint);
  }

  previewImage(): Observable<Blob> {
    return this.crudService.getExportData(`${this.imageEndpoint}/preview`, undefined, 'blob');
  }

  uploadImage(file: File): Observable<SupplierInvitationBrandAssetResponse> {
    const data = new FormData();
    data.append('image', file, file.name);

    return this.crudService.postCommand<SupplierInvitationBrandAssetResponse>(this.imageEndpoint, data);
  }

  removeImage(): Observable<SupplierInvitationBrandAssetResponse> {
    return this.crudService.deleteCommand<SupplierInvitationBrandAssetResponse>(this.imageEndpoint);
  }
}
